import { render, staticRenderFns } from "./expense.vue?vue&type=template&id=746e1bee&scoped=true&"
import script from "./expense.vue?vue&type=script&lang=js&"
export * from "./expense.vue?vue&type=script&lang=js&"
import style0 from "./expense.vue?vue&type=style&index=0&id=746e1bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746e1bee",
  null
  
)

export default component.exports